import React from 'react';

import type { FrapiTeaserItemSized } from '../../../types/frapi-types.js';

import TeaserWrapper from './TeaserWrapper.js';
import Image from './teaserComponents/Image.js';
import Price from '../articles/articleComponents/Price.js';
import { orderTeaserTags } from '../search/helpers.js';
import {
  filterTagsOnType,
  isExperience,
  isNews,
  isRestaurantReview,
  isReview,
  makeTagTitle,
} from '../articles/helpers.js';
import { hasPrice } from '../commonComponents/imageUtils.js';
import TimeStamp from '../articles/articleComponents/Timestamp.js';
import TeaserGrade from './teaserComponents/TeaserGrade.js';
import TeaserTag from './teaserComponents/TeaserTag.js';

const TeaserSearchResult: React.FC<FrapiTeaserItemSized> = (t) => {
  const isGuide = !isReview(t);

  const filteredTags = filterTagsOnType(t.tags, [
    'område',
    'type',
    'mattype',
    'strømmetjeneste',
  ]);

  const getSubtitle = (t: FrapiTeaserItemSized) => {
    let kickerText = t.kicker;

    if (!t.kicker) {
      if (isNews(t) || isExperience(t)) {
        kickerText = t.hasGroups ? 'Guide' : 'Nyheter';
      } else {
        return t.section;
      }
    }

    return `${t.section}, ${kickerText}`;
  };

  const tilteClassname = 'title ' + (isGuide ? 'three-lines' : 'two-lines');

  return (
    <TeaserWrapper
      classNames="teaser-search-result teaser"
      teaser={t}
      isMobile={t.mobile}
      bundleId={t.bundleId}
    >
      <div className="heading-wrapper">
        <div className={tilteClassname}>{!isGuide ? t.kicker : t.title}</div>
        <div className="grade-info-wrapper">
          {!isGuide ? (
            t.grade && <TeaserGrade grade={t.grade} />
          ) : (
            <div className="sub-title">{getSubtitle(t)}</div>
          )}
          {isRestaurantReview(t) ? (
            <TimeStamp
              published={t.publicationDate}
              updated={t.publicationDate}
              forTeaserCard={true}
            />
          ) : (
            !isGuide && <TeaserTag tags={t.tags} section={t.section} />
          )}
        </div>
      </div>
      <div className="image-container">
        {t.image && (
          <Image
            imageAsset={t.image}
            title={t.title}
            width={180}
            height={180}
            size={t.size}
          />
        )}
      </div>
      {!isGuide && (
        <div className="tag-wrapper">
          {hasPrice(t) && isRestaurantReview(t) && (
            <div className="regular-tag">
              <Price price={t.priceLevel} />
            </div>
          )}
          {orderTeaserTags(filteredTags)
            .slice(0, hasPrice(t) ? 2 : 3)
            .map((tag, i) => (
              <div key={i} className="regular-tag">
                {makeTagTitle(tag.title)}
              </div>
            ))}
        </div>
      )}
    </TeaserWrapper>
  );
};
export default TeaserSearchResult;
